export enum EClaimCode {
    HPortal = 1,
    //Waseel = 2,
    Nphies = 3,
}
